// hooks/useHeartbeat.js
import { useEffect } from 'react';
import api from '../api/api';

const getAuthHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`,
});

export function useHeartbeat(intervaloMs = 30_000) {
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;

    const enviar = () =>
      api.post('/usuarios/heartbeat', {}, { headers: getAuthHeader() })
        .catch(() => {}); // silencia erros de rede

    enviar(); // dispara imediatamente ao montar
    const id = setInterval(enviar, intervaloMs);

    // Pausa quando a aba perde o foco, retoma quando volta
    const onVisible = () => { if (document.visibilityState === 'visible') enviar(); };
    document.addEventListener('visibilitychange', onVisible);

    return () => {
      clearInterval(id);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [intervaloMs]);
}